import { connect } from "react-redux";
import Gallery from "./gallery";
import React from "react";
import { withRouter } from "react-router-dom";
import { updateGallery, createGallery, deleteGallery } from "../../../actions/service_actions";
import { closeModal } from "../../../actions/modal_actions";
import {showToast} from "../../../actions/toast_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  currentUser: state.entities.users[state.session.currentUser.id],
});

const mdp = (dispatch) => ({
  updateGallery: (gallery_data, gallery_id) => dispatch(updateGallery(gallery_data, gallery_id)),
  createGallery: (gallery_data) => dispatch(createGallery(gallery_data)),
  deleteGallery: (gallery_id) => dispatch(deleteGallery(gallery_id)),
  closeModal: () => { dispatch(closeModal()) },
  showToast: (message) => dispatch(showToast(message))
});

export default withRouter(connect(msp, mdp)(Gallery));